import { Pipe, PipeTransform } from '@angular/core';
import { Subscription } from '../models/subscription';

@Pipe({
  standalone: false,
  name: 'userSubscriptionFilter',
})
export class UserSubscriptionFilterPipe implements PipeTransform {
  transform(userList: Subscription[], searchString: string): Subscription[] {
    if (searchString == undefined) return userList;

    searchString = searchString.toLowerCase();
    var result = userList.filter((item: Subscription) => {
      return (
        item.partitionKey.toLowerCase().includes(searchString) ||
        item.eventName.toLowerCase().includes(searchString)
      );
    });
    return result;
  }
}

